<script setup lang="ts">
import PathwayLandingFeatures from '@/components/views/pathway/landing-page/PathwayLandingFeatures.vue'
import PathwayLandingFooter from '@/components/views/pathway/landing-page/PathwayLandingFooter.vue'
import PathwayLandingHero from '@/components/views/pathway/landing-page/PathwayLandingHero.vue'
import PathwayLandingNavbar from '@/components/views/pathway/landing-page/PathwayLandingNavbar.vue'
import PathwayLandingProcess from '@/components/views/pathway/landing-page/PathwayLandingProcess.vue'
import PathwayLandingTypes from '@/components/views/pathway/landing-page/PathwayLandingTypes.vue'
</script>

<template>
  <div class="font-archivo bg-pw-ink text-pw-paper min-h-screen antialiased">
    <PathwayLandingNavbar />
    <PathwayLandingHero />
    <PathwayLandingProcess />
    <PathwayLandingTypes />
    <PathwayLandingFeatures />
    <PathwayLandingFooter />
  </div>
</template>

<style>
html {
  scroll-behavior: smooth;
}
</style>
